export const shopsData = [
  {
    name: '神戸本店',
    address: '〒650-0041 神戸市中央区新港町17-3 W102',
    hours: '9:00-17:00',
    brunchHours: '朝食・ブランチ 9:00-14:00',
    closed: '定休日：火曜・金曜',
    phone: 'TEL: 078-585-5388',
    feature: '海沿い、みなとのもり公園・メリケンパークから徒歩圏内',
    image: 'https://readdy.ai/api/search-image?query=Charming%20handmade%20ice%20cream%20shop%20exterior%20by%20the%20seaside%20in%20Kobe%20Japan%2C%20vintage%201950s%20American%20diner%20style%20storefront%20with%20large%20windows%2C%20retro%20mint%20green%20and%20coral%20pink%20signage%2C%20wooden%20details%2C%20welcoming%20entrance%2C%20ocean%20view%20in%20background%2C%20bright%20daylight%2C%20nostalgic%20yet%20modern%20aesthetic&width=600&height=400&seq=kobe-exterior-001&orientation=landscape'
  },
  {
    name: '東京店',
    address: '〒150-0012 東京都渋谷区広尾3-2-12',
    hours: '12:00-18:00',
    brunchHours: '',
    closed: '定休日：火曜・金曜',
    phone: 'TEL: 050-1143-7179',
    feature: '広尾の閑静な住宅街',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20handmade%20ice%20cream%20shop%20in%20quiet%20residential%20Hiroo%20Tokyo%20neighborhood%2C%20elegant%20storefront%20with%20vintage%20American%20parlor%20touches%2C%20modern%20minimalist%20exterior%20with%20retro%20elements%2C%20large%20glass%20windows%2C%20soft%20afternoon%20light%2C%20peaceful%20urban%20setting%2C%20refined%20and%20inviting%20atmosphere&width=600&height=400&seq=tokyo-exterior-001&orientation=landscape'
  }
];
